import { render, staticRenderFns } from "./ClientAddressesList.vue?vue&type=template&id=d89abe94&"
import script from "./ClientAddressesList.vue?vue&type=script&lang=js&"
export * from "./ClientAddressesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports